export const GET_NEWCOINS_BALANCES_REQUEST = "GET_NEWCOINS_BALANCES_REQUEST"
export const GET_NEWCOINS_BALANCES_SUCCESS = "GET_NEWCOINS_BALANCES_SUCCESS"
export const GET_NEWCOINS_BALANCES_FAILURE = "GET_NEWCOINS_BALANCES_FAILURE"
export const GET_NEXT_PAGE_NEWCOINS_BALANCES_REQUEST = "GET_NEXT_PAGE_NEWCOINS_BALANCES_REQUEST"
